import { Component, EventEmitter, Output, ViewChild, AfterViewInit, OnInit, TemplateRef, OnDestroy, Renderer2 } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EmailAndSMSService } from 'src/app/services/operations/EmailAndSMS.service';
import { CalltrackerService } from 'src/app/services/operations/calltracker.service'
import { UserSessionService } from 'src/app/services/usersession.service';
import { ToastrService } from 'ngx-toastr';
import { IStore } from 'src/app/Shared/interface';
import { GridComponent, GridLine } from '@syncfusion/ej2-angular-grids';

@Component({
  selector: 'app-relink-email',
  templateUrl: './email-relink-popup.component.html',
  styleUrls: ['./email-relink-popup.component.scss'],
  standalone: false
})
export class EmailRelinkPopupComponent implements AfterViewInit, OnInit, OnDestroy {
  @Output() onRelinkSuccess = new EventEmitter<any>();
  @ViewChild('grid', { static: false }) public gridData: GridComponent;
  public loaderIcon: Promise<boolean>;
  public filterSettings = { type: 'FilterBar', mode: 'Immediate' };
  public lines: GridLine = 'Both';
  emailData: any;
  loading = false;
  selectedRecord: any = null;
  searchModel = {
    facilityId: '',
    confirmationNumber: '',
    unitNumber: '',
    tenantName: '',
    email: ''
  };
  allStores: IStore[] = [];
  resultList: any[] = [];
  selectedFacilityId: number | null = null;
  lastAccessedFacility;
  isCallCenterAgent = false;
  modalRef: BsModalRef;

  constructor(private emailAndSMSService: EmailAndSMSService,
    private userSessionService: UserSessionService,
    private toastr: ToastrService,
    private bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private callTrackerService: CalltrackerService,
    private renderer: Renderer2) { }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (!this.gridData) return;
      const filterCells = this.gridData.element.querySelectorAll('.e-filterdiv');
      const columns = this.gridData.columns as any[];
      // Find Select column by headerText
      const selectIndex = columns.findIndex(c => c.headerText === 'SELECT');
      if (selectIndex !== -1 && filterCells[selectIndex]) {
        filterCells[selectIndex].classList.add('e-hide');
      }
    }, 0);
  }
  ngOnInit(): void {
    this.renderer.addClass(document.body, 'overflow-x-hidden');
    this.isCallCenterAgent = this.userSessionService.isCallcenterAgent;
    this.lastAccessedFacility = this.userSessionService.userSessionData?.LastAccessedStoreId;
    if (!this.isCallCenterAgent && this.lastAccessedFacility) {
      this.selectedFacilityId = this.lastAccessedFacility;
      this.searchModel.facilityId =
        this.lastAccessedFacility.toString();
    }
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'overflow-x-hidden');
  }

  proceedRelink() {
    if (!this.selectedRecord) {
      return;
    }
    this.loading = true;
    const payload: any = {
      EmailLogId: this.emailData.EmailId,
      ExistingTenantEmail: true,
      TenantID: this.selectedRecord.TenantId,
      FacilityId: this.selectedFacilityId,
      LeaseNo: null,
      ReservationNumber: null,
      InquiryNumber: null,
    };

    switch (this.selectedRecord.Type) {
      case 'RENTAL': payload.LeaseNo = Number(this.selectedRecord.ConfirmationNumber);
        break;
      case 'RESERVATION': payload.ReservationNumber = Number(this.selectedRecord.ConfirmationNumber);
        break;

      case 'INQUIRY': payload.InquiryNumber = Number(this.selectedRecord.ConfirmationNumber);
        break;
    }

    this.emailAndSMSService.SaveEmails(payload).subscribe({
      next: () => {
        this.loading = false;
        this.modalRef.hide();
        this.onRelinkSuccess.emit({ success: true });
        this.bsModalRef.hide();
      },

      error: () => {
        this.loading = false;
        this.modalRef.hide();
        this.onRelinkSuccess.emit({ success: false });
        this.bsModalRef.hide();
      }
    });
  }
  cancel() {
    this.bsModalRef.hide();
    if (this.emailData?.parentModal) {
      this.emailData.parentModal.show();
    }
  }
  searchTenantRecords() {
    const payload = {
      facilityId: this.selectedFacilityId,
      confirmationNumber: this.searchModel.confirmationNumber,
      unitNumber: this.searchModel.unitNumber,
      tenantName: this.searchModel.tenantName,
      email: this.searchModel.email
    };
    this.loading = true;
    this.callTrackerService.GetTenantRecordsToRelink(payload).subscribe({
      next: (res: any[]) => {

        this.resultList = res || [];
        this.selectedRecord = null;
        this.loading = false;
        if (!this.resultList.length) {
          this.toastr.warning('No records found');
        }
      },
      error: () => {
        this.loading = false;
        this.toastr.error('Failed to fetch records');
      }
    });

  }
  onSelectRecord(data: any) {
    this.selectedRecord = data;
  }

  canSearch(): boolean {
    return !!(
      this.selectedFacilityId &&
      (
        this.searchModel.confirmationNumber ||
        this.searchModel.unitNumber ||
        this.searchModel.tenantName ||
        this.searchModel.email
      )
    );
  }
  formatPhoneNumber(phone: string): string {
    if (!phone) {
      return '';
    }

    const matches = phone.match(/\d{10}\s*\([CHWB]\)/g);
    const phones: string[] = [];

    matches?.forEach(item => {
      const digits = item.match(/\d{10}/)?.[0];
      const suffix = item.match(/\([CHWB]\)/)?.[0] ?? '';

      if (digits) {
        phones.push(
          `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)} ${suffix}`
        );
      }
    });

    return phones.join(' / ');
  }
  openRelinkConfirmation(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: 'modal-dialog-centered modal-sm'
    });
  }

  proceedRemoveLink() {
    if (!this.emailData?.EmailId) { return; }
    this.loading = true;
    this.emailAndSMSService.removeEmailLink(this.emailData.EmailId, null).subscribe({
      next: () => {
        this.loading = false;
        this.modalRef.hide();
        this.onRelinkSuccess.emit({ success: true, action: 'remove' });
        this.bsModalRef.hide();
      },
      error: () => {
        this.loading = false;
        this.modalRef.hide();
        this.onRelinkSuccess.emit({ success: false, action: 'remove' });
        this.bsModalRef.hide();
      }
    });
  }
}
